import { render, staticRenderFns } from "./QRReader.vue?vue&type=template&id=bf76c49a"
import script from "./QRReader.vue?vue&type=script&lang=js"
export * from "./QRReader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports